import {FC} from 'react';
import {Alert} from 'reactstrap';
import {useOidcLogout} from '@touchnet/react-oidc';
import {useDispatch} from 'react-redux';

import WhiteoutWrapper from '~/components/general/whiteout';
import useEffectOnce from '~/hooks/use-effect-once';
import {AuthActions} from "@touchnet/react-auth";
import {PERSISTED_STATE_KEY} from "~/constants";


export const LogoutPage: FC = () => {
    const logout = useOidcLogout();
    const dispatch = useDispatch();

    useEffectOnce(() => {
        dispatch(AuthActions.logout());
        window.sessionStorage.removeItem('persist:' + PERSISTED_STATE_KEY);
        logout();
    });

    return (
        <WhiteoutWrapper>
            <Alert color="warning">
              Logging out...
            </Alert>
        </WhiteoutWrapper>
    );
};

export default LogoutPage;
